export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/5018b541d15d042d.png"